<template>
  <ProductSeriesPage
    :title="title"
    :subtitle="subtitle"
    :hero-image="heroImage"
    :items="items"
  />
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import ProductSeriesPage from '@/components/ProductSeriesPage.vue'
import seriesProductImages from '../seriesProductImages'

const { t, tm, locale } = useI18n()
const heroImage = require('@/assets/images/pixso-automotive-products/hero-imu.png')
const isEnglish = computed(() => locale.value === 'en')

const title = computed(() => t('AutomotiveIndex.series.items.imu.title'))
const subtitle = computed(() => (isEnglish.value ? '' : t('AutomotiveIndex.series.items.imu.subtitle')))
const itemImages = [
  seriesProductImages.im13m,
  seriesProductImages.im16m,
  seriesProductImages.im18m,
  seriesProductImages.im21,
  seriesProductImages.ib11
]

const itemLinks = [
  '/product/automotive/imu/im13-m',
  '/product/automotive/imu/im16-m',
  '/product/automotive/imu/im18-m',
  '/product/automotive/imu/im21',
  '/product/automotive/imu/ib11'
]

const items = computed(() => {
  const seriesItems = tm('IM11.series.items') || []

  return seriesItems.map((item, index) => ({
    title: item.title,
    description: item.description,
    image: itemImages[index],
    to: itemLinks[index]
  }))
})
</script>
